/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const Insurance = {
  path: '/complete-machine-delivery',
  name: 'complete-machine-delivery',
  redirect: { name: 'jijia-order' },
  component: () => import('@/views/complete-machine-delivery/index.vue'),
  children: [
    {
      path: 'delivery-service',
      name: 'delivery-service',
      component: () =>
        import(
          /* webpackChunkName: "complete-machine-delivery" */ '@/views/complete-machine-delivery/delivery-service.vue'
        ),
    },
    {
      path: 'delivery-service-list',
      name: 'delivery-service-list',
      component: () =>
        import(
          /* webpackChunkName: "complete-machine-delivery" */ '@/views/complete-machine-delivery/delivery-service-list.vue'
        ),
    },
    {
      path: 'delivery-service-detail',
      name: 'delivery-service-detail',
      component: () =>
        import(
          /* webpackChunkName: "complete-machine-delivery" */ '@/views/complete-machine-delivery/delivery-service-detail.vue'
        ),
    },
    {
      path: 'delivery-service-evaluation',
      name: 'delivery-service-evaluation',
      component: () =>
        import(
          /* webpackChunkName: "complete-machine-delivery" */ '@/views/complete-machine-delivery/delivery-service-evaluation.vue'
        ),
    },
  ],
}
export default Insurance
